import React from "react";
import { fmtINR, posNeg } from "../lib/format";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export const KpiCard = ({ label, value, sub, delta, deltaLabel, format = "inr", accent = false, testId, right }) => {
    const isNumericDelta = typeof delta === "number";
    const trendIcon = isNumericDelta
        ? (delta > 0 ? <TrendingUp size={12} /> : delta < 0 ? <TrendingDown size={12} /> : <Minus size={12} />)
        : null;

    return (
        <div
            data-testid={testId}
            className={`pbi-card p-4 rise-in relative hover:bg-[var(--bg-panel-hover)] transition-colors ${accent ? "ring-1 ring-[var(--brand-amber)]" : ""}`}
        >
            <div className="flex items-start justify-between mb-2">
                <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--text-secondary)]">
                    {label}
                </div>
                {right}
            </div>
            <div className="font-mono-fin text-2xl md:text-3xl font-semibold tracking-tight text-[var(--text-primary)]">
                {format === "inr" ? fmtINR(value) : value}
            </div>
            {(sub || isNumericDelta) && (
                <div className="mt-2 flex items-center gap-2 text-[11px]">
                    {isNumericDelta && (
                        <span className={`inline-flex items-center gap-1 font-semibold ${posNeg(delta)}`}>
                            {trendIcon}
                            {Math.abs(delta).toFixed(1)}%
                        </span>
                    )}
                    {deltaLabel && <span className="text-[var(--text-muted)]">{deltaLabel}</span>}
                    {sub && <span className="text-[var(--text-secondary)]">{sub}</span>}
                </div>
            )}
            {accent && <div className="absolute top-0 left-0 h-[3px] w-full bg-[var(--brand-amber)] rounded-t" />}
        </div>
    );
};

export default KpiCard;
